import { Building2, Flag, Globe, Home } from "lucide-react";
import { Address } from "../../../types/address.types";

export interface ITMAddressesInfoDisplayProps {
  addresses: Address[];
}

export default function TMAddressesInfoDisplay({
  addresses,
}: ITMAddressesInfoDisplayProps) {
  return (
    <>
      {addresses && addresses.length > 0 ? (
        <div className="border border-gray-400 rounded-md p-4">
          <h3 className="text-lg font-bold mb-2">Dirección</h3>
          {addresses.map((address, index) => (
            <div key={index} className="pt-2 rounded-md">
              <p className="text-gray-800 flex flex-wrap items-center gap-1">
                <Home className="w-5 h-5 text-gray-600" />
                <span className="font-semibold">Dirección:</span>{" "}
                {address.address_line}
              </p>
              <p className="text-gray-800 flex flex-wrap items-center gap-1">
                <Building2 className="w-5 h-5 text-gray-600" />
                <span className="font-semibold">Ciudad:</span> {address.city}
              </p>
              <p className="text-gray-800 flex flex-wrap items-center gap-1">
                <Globe className="w-5 h-5 text-gray-600" />
                <span className="font-semibold">Provincia:</span>{" "}
                {address.state}
              </p>
              <p className="text-gray-800 flex flex-wrap items-center gap-1">
                <Flag className="w-5 h-5 text-gray-600" />
                <span className="font-semibold">País:</span> {address.country}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-600">No hay direcciones disponibles.</p>
      )}
    </>
  );
}
